import { Filters, SimpleEnumType } from '@/types';
import { DispatchStatuses, DispatchReturnStatuses } from '@/enums/statuses/dispatches';
import { DispatchReason, DispatchType } from '@/enums/dispatches/index';
import { Organizations } from '@/modules/organizations/types';

export namespace Dispatches {
  export enum Pages {
    DISPATCHES = 'dispatches',
    DISPATCH_DETAIL = 'dispatch',
    DISPATCH_CORRECTIVE = 'corrective',
    REALIZATIONS = 'realizations'
  }
  export interface Dispatch {
    [key: string]: unknown;
    id?: number;
    dispatch_number: number | null;
    date: string | null;
    organization: Organizations.Organization;
    agreement: string | number | null;
    document_sum: string | number | null;
    status: SimpleEnumType<DispatchStatuses>;
    status_edo: SimpleEnumType<DispatchStatuses> | null;
    has_unread_change: boolean;
  }

  export interface SerialNumber {
    id: number;
    number: string | null;
  }

  export interface Product {
    id: number;
    order_id: number | null;
    nomenclature: string | null;
    price: string | null;
    product_code: string | null;
    serial_numbers: SerialNumber[];
    quantity: number | null;
    nds: number | null;
    sum_nds: string | null;
    total_price: string | null;
  }

  export interface DispatchDetailedFile {
    created_at: string;
    id: number;
    name: string;
    register_realization_corrective_id?: number;
  }

  export interface DispatchDetailedInfo {
    [key: string]: unknown;
    id: number;
    create_at: string;
    products: Product[];
    organization: Organizations.Organization | null;
    total_volume: string | null;
    total_weight: string | null;
    amount_contract: string | null;
    status: SimpleEnumType<DispatchStatuses> | null;
    status_edo: SimpleEnumType<DispatchStatuses> | null;
    contract: string | null;
    files: DispatchDetailedFile[];
    track_number: string | null;
    order_id: number | null;
  }

  export interface DispatchСorrective {
    [key: string]: unknown;
    id: number;
    amount_contract: number | null;
    contract: string | null;
    create_at: string | null;
    external_number: string | null;
    number_upd: string | null;
    organization: string | null;
    organization_external: string | null;
    parent_realization_id: number;
    parent_realization_number: string | null;
    products: Product[];
    status: SimpleEnumType<DispatchStatuses> | null;
    status_edo: SimpleEnumType<DispatchStatuses> | null;
  }

  export interface DispatchDocument {
    name: string;
    path: string;
  }

  export interface DispatchReturn {
    [key: string]: unknown;
    id: number;
    nomenclature: string | null;
    product_code: string | null;
    return_date: string | null;
    serial_number: string | null;
    return_reason: SimpleEnumType<DispatchReason>;
    return_type: SimpleEnumType<DispatchType>;
    returned_at: string | null;
    register_realization_corrective_number: string | null;
    register_realization_corrective_id: number | null;
    register_realization_corrective_status: SimpleEnumType<DispatchStatuses>;
    return_status: SimpleEnumType<DispatchReturnStatuses>;
  }

  export interface Document {
    id: number;
    name: string | null;
    path?: string | null;
    created_at: string | null;
  }

  export type ExelInfo = Pick<Document, 'path'>;

  export interface Categories {
    id: number | string;
    category_name: string;
  }

  export interface Products {
    id: number | string;
    nomenclature: string;
  }
}

export interface DispatchesFilters extends Filters {
  [key: string]: unknown;
  organization_external: string | null;
  organization: string[] | null;
  contract: string[] | null;
  date: string[] | null;
  only_has_unread_changes: boolean;
}

export interface DownloadFilters {
  [key: string]: unknown;
}
